export const LOGIN_API = 'login';
export const FORGET_PASSWORD_API = 'forgot-password';
export const CHANGE_PASSWORD_API = 'change-password';
export const RESET_PASSWORD_API = 'reset-password';
export const ALL_USERS = 'users?status=true';
export const CREATE_PROJECT_BASIC_INFO = 'create-project';
export const CREATE_PROJECT_TIMELINE_INFO = 'addStage';
export const CREATE_PROJECT_BUDGET_INFO = 'addBudgetInfo';
export const CREATE_PROJECT_TRAINIG_INFO = 'addTraining';
export const CREATE_PROJECT_QUOTA_INFO = 'create-quota';
export const CREATE_PROJECT_INTERLINK_INFO = 'InterLink';
export const PROFILE_DETAILS_API = 'user';
export const PROJECT_LIST_API = 'projects';
export const PROJECT_DETAILS_API = 'project';
export const PROJECT_STATUS_LIST_API = 'project-status-list';
export const VERIFY_OTP_API = 'reset-password';
export const ADMIN_DASHBOARD_API = 'get-admin-overview';
export const ADMIN_DASHBOARD_CHART_API = 'get-project-trends';
export const ADMIN_DASHBOARD_RESOURCE_AVAILABLE = 'get-resource-available';
export const RD_DASHBOARD_API = 'rd/get-project-chart';
export const RD_DASHBOARD_PROJECT_PROGRESS_API = 'rd/project-progress';
export const BUDGET_LIST_API = 'budget-list';
export const ADD_DEVICE_API = 'add-device';
export const DEVICE_LIST_API = 'get-devices';
export const GET_DEVICES_AVAILABLE_API = 'get-devices-available';
export const GET_DEVICE_DETAILS_API = 'device';
export const DELETE_DEVICE_BY_ID = 'device';
export const GET_DEVICE_HISTORY = 'device-history';
export const TABLET_BRANDS_API = 'tablet-brands';
export const TABLET_MODELS_API = 'tablet-models';
export const ADD_TRAINING_API = 'addTraining';
export const GET_CATEGORY_LIST = 'training-categories';
export const GET_MODULE_LIST = 'get-enum-module';
export const GET_TRAINING_LIST = 'get-training-list';
export const GET_TRAINING_BY_ID_LIST = 'get-training-by-id';
export const GET_RECRUITMENT_REQUEST_LIST = 'recruitment/requests-list';
export const GET_STOREKEEPER_DASHOBOARD =
  'storekeeper/recently-assigned-project';
export const GET_STOREKEEPER_REQUEST_LIST = 'device-requests';
export const GET_HR_TRAINING_AVAILABILITY = 'hr/training-overview';
export const GET_HR_PROJECT_REQUEST = 'hr/summary-by-project-request';
export const GET_USERS_BY_ROLE = 'users-by-role';
export const GET_PROJECT_LIST_BY_MEMBER = 'project-list-by-member';
export const INTERVIEWER_PROJECT_LIST_API = 'interviewer/project-list';
export const GET_DEPARTMENT = 'get-enum-department';
export const GET_ALL_ROLES = 'getRoles';
export const FIRST_TIME_LOGIN = 'change-first-login-password';
export const PAYMENT_LIST_API = 'get-payment-list';
export const PAYMENT_OVERVIEW_API = 'payment-overview';
export const LOGOUT = 'logout';
